import { useEffect } from "react";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

interface PageSeoOptions {
  title: string;
  description: string;
  ld?: object;
}

/**
 * 单页应用内逐页更新 title / description / og，并注入（可替换的）JSON-LD。
 */
export function usePageSeo({ title, description, ld }: PageSeoOptions) {
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    // 管理动态 JSON-LD
    const scriptId = "page-seo-ld";
    const prev = document.getElementById(scriptId);
    if (prev) prev.remove();
    if (ld) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = scriptId;
      s.textContent = JSON.stringify(ld);
      document.head.appendChild(s);
    }
  }, [title, description, ld]);
}